import { useFormContext } from 'react-hook-form';

import { useGetChangeTaskSubTypeQuery } from '@xemplo/amendment-query';
import { useGetBusinessUnitsQuery } from '@xemplo/business-unit-query';

import { FormFields } from '../../../../create-amendment.types';

import * as S from './bulk-upload-summary.styles';

export const SummaryHeader = () => {
  const { getValues } = useFormContext<FormFields>();
  const changeTask = getValues('changeTask');
  const changeTaskSubType = getValues('changeTaskSubType');
  const businessUnit = getValues('businessUnit');

  const { data: businessUnitData } = useGetBusinessUnitsQuery({});
  const { data: subTypeData } = useGetChangeTaskSubTypeQuery({
    requestParams: {
      q: {
        changeTaskValueId: changeTask,
        businessUnitId: businessUnit,
      },
    },
  });
  const subType = subTypeData?.find((type) => type.id === changeTaskSubType);
  const businessUnitName = businessUnitData?.result.rows.find(
    (row) => row.id === businessUnit,
  )?.name;

  const changeTaskName = subType?.changeTaskValue;
  const changeTaskType = subType?.name;

  return (
    <S.Details>
      <S.DetailItem>
        <div>Change Type</div>
        <div>Payrun</div>
      </S.DetailItem>
      <S.DetailItem>
        <div>Business Unit</div>
        <div>{businessUnitName}</div>
      </S.DetailItem>
      <S.DetailItem>
        <div>Change Task</div>
        <div>{changeTaskName}</div>
      </S.DetailItem>
      <S.DetailItem>
        <div>{changeTaskName} Type</div>
        <div>{changeTaskType}</div>
      </S.DetailItem>
    </S.Details>
  );
};
